import fetch from "isomorphic-fetch";
import { toast } from "saphir";
import { z } from "zod";

import { i18n } from "@lib/i18n";
import { handleError } from "@lib/utils/error";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";

export const shiftShchema = z.object({
    startDate: z.iso.datetime(),
    endDate: z.iso.datetime(),
    breakDuration: z.number(),
    slots: z.number(),
    recurrence: z
        .object({
            type: z.enum(["weekly", "monthly"]),
            interval: z.number().min(1).max(50),
            until: z.iso.datetime(),
            withHolidays: z.boolean().catch(false),
            days: z.array(z.number().min(0).max(6)).optional(),
            setPos: z.array(z.number().min(-4).max(4)).optional(),
        })
        .optional(),
});

const addShiftParamsSchema = z.object({
    taskId: z.string(),
    shift: shiftShchema,
});

export type AddShiftParams = z.input<typeof addShiftParamsSchema>;
export async function addShift({ taskId, shift }: AddShiftParams) {
    try {
        const resp = await fetch(
            withAccountAuthHeaders(`${apiConf.BACK_URL}/tasks/${taskId}/shifts`, {
                method: `POST`,
                body: JSON.stringify(shift),
            }),
        );

        if (resp.status === 400) {
            toast.error(i18n.error_invalid_shift());
            return {};
        }

        if (resp.status >= 400) {
            handleError(await resp.json(), resp.status);
            return Promise.reject(new Error("addShift"));
        }

        return resp.json();
    } catch (e) {
        handleError(e, 500);
        return Promise.reject(new Error("addShift"));
    }
}
